import { render, staticRenderFns } from "./PillBadgeLinkBlock.vue?vue&type=template&id=21a0af03&"
import script from "./PillBadgeLinkBlock.vue?vue&type=script&lang=js&"
export * from "./PillBadgeLinkBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports